export interface GeocoderAddressComponent {
  short_name: string
  long_name: string
  types: string[]
}

// eslint-disable-next-line i18next/no-literal-string -- Google Places API type identifiers
const PLACE_TYPES = {
  postalCode: 'postal_code',
  adminArea: 'administrative_area_level_1',
  locality: 'locality',
  subLocality: 'sublocality_level_1',
  postalTown: 'postal_town',
} as const

const getAddressComponent = (addressComponents: GeocoderAddressComponent[], type: string) =>
  addressComponents?.find(component => component.types.includes(type))

/** Parses Google Places `address_components` (same field logic as web-checkout address.helper getAddress). */
export function getAddressFromPlaceComponents(addressComponents: GeocoderAddressComponent[]) {
  const rawZip = getAddressComponent(addressComponents, PLACE_TYPES.postalCode)?.short_name ?? ''
  const provinceCode = getAddressComponent(addressComponents, PLACE_TYPES.adminArea)?.short_name ?? ''
  const city = getAddressComponent(addressComponents, PLACE_TYPES.locality)?.long_name ?? ''
  const subLocality = getAddressComponent(addressComponents, PLACE_TYPES.subLocality)?.long_name ?? ''
  const postalTown = getAddressComponent(addressComponents, PLACE_TYPES.postalTown)?.short_name || ''
  return {
    zip: rawZip,
    provinceCode,
    city: city || subLocality || postalTown,
  }
}
